import { render, staticRenderFns } from "./ProtobofSchema.vue?vue&type=template&id=817bdf7a"
import script from "./ProtobofSchema.vue?vue&type=script&lang=js"
export * from "./ProtobofSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports